import React, { useCallback, useContext, useState } from 'react';
import { xs_isMobile } from '../..';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import SocialButtons from '../../data/my-bets/SocialButtons';
import { formatDate, getConfiguration, getDBTimestampFromDate, getReservationCodeType, getBetslipPage } from '../../data/utils';
import { getLabel } from '../../InitData';
import { ReservationPrinter } from '../betslip/reservation-detail/ReservationPrinter';
import { getEnv } from '../env';

function getFormattedDate(timestamp) {
    const reservationDate = new Date();
    reservationDate.setTime(timestamp);
    return formatDate(getDBTimestampFromDate(reservationDate), true).formatted;
}

function ReservationHistory(props) {
	const betslipContext = useContext(BetslipContext) ;
	const [printCode, setPrintCode] = useState(null);
   
    function printTicket(code) {
		setPrintCode(code);
    }
    
    function endPrintFunction(){
    	if (window.appConfig.SHOP_BOOKER) {
            betslipContext.removeReservation(printCode);
        }
        setPrintCode(null);
    }

    let reservations = props.reservations;
    const getTicketURL = useCallback((code) => {
//        const baseURL = getBaseURL();
    	//const baseURL = (loadedInIframe()?window.top:window.self).location.origin;
        const baseURL = window.location.origin;
    	const betslipPage = getBetslipPage(xs_isMobile);
        return `${baseURL}${betslipPage}?reservationCode=${code}`;
    }, []);
    
    return (
        <div className="reservationHistory">
        	{printCode && <ReservationPrinter codeList={[printCode]} endFunction={() => { endPrintFunction(); }} />}
            <div className="reservationHeader">{getLabel('betslip_alt.reservations_made')}: {reservations.length}</div>
            <div className="reservationListContainer">		
                {reservations.map(function(res) {
                    const reactKey = `reservation-${res.code}`;
                    return <React.Fragment key={reactKey}>
                        <div className="reservationRow">
                            <div onClick={() => {betslipContext.removeReservation(res.code)}} className="deleteReservation pointer">
                                <img src={`${getEnv('PUBLIC_URL')}/assets/images/icon_close.svg`} alt="" />
                            </div>
                            <div className="inputReservationContainer reservationData">
                                <span className="reservationTimestamp">{getFormattedDate(res.timestamp)}</span>
                                <span className="margine-dx grassetto">{res.code}</span>
                            </div>
                            <div className="reservationButtonsContainer">
                                <div className="reservation-buttons-row">
                                    <div id="xs-reservation-detail-btn" onClick={() => betslipContext.openReservationDetail(res.code)} className="reloadReservationButton">
                                        <span>{getLabel('betslip_alt.reservations.detail')}</span>
                                        {/* <i className="fa fa-ticket-alt"></i> */}
                                    </div>
                                    <div id="xs-reservation-print-btn" onClick={() => printTicket(res.code)} className="reloadReservationButton">
                                        <span>{getLabel('betslip_alt.reservations.print')}</span>
                                        {/* <i className="fa fa-print"></i> */}
                                    </div>
                                    <div id="xs-reservation-reload-btn" onClick={() => betslipContext.reloadReservedTicket(res.code)} className="reloadReservationButton">
                                        <span>{getLabel('betslip_alt.reservations.load')}</span>
                                        {/* <i className="fa fa-shopping-cart"></i> */}
                                    </div>
                                </div>
                                <div className="reservation-buttons-row">
                                    <SocialButtons message={getLabel('betslip_alt.reservations.share_ticket')} ticketUrl={getTicketURL(res.code)} />
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                })}
            </div>
            <div className="closeReservationButtonContainer">
                <button onClick={() => betslipContext.toggleReservationBox()} className="bottone bg-rosso bianco">{getLabel('betslip_alt.reservations.close')}</button>
            </div>
        </div>
   );
}

export default ReservationHistory;